import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function Header() {
  const location = useLocation();

  return (
    <header className="header">
      <div className="header-inner">
        <Link to="/">
          <img src="/images/logo.png" alt="Megapixel Photos" className="logo" />
        </Link>
        <nav className="nav">
          <Link to="/" className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}>Home</Link>
          <Link to="/gallery" className={`nav-link ${location.pathname === '/gallery' ? 'active' : ''}`}>Gallery</Link>
          <a href="mailto:robert.higareda@gmail.com" className="nav-link">Contact</a>
          <a href="https://www.instagram.com/official_megapixelphotos" target="_blank" rel="noopener noreferrer" className="nav-link nav-ig">
            📷 Instagram
          </a>
        </nav>
      </div>
    </header>
  );
}

export default Header;
